export const BNPL_LIMITS_OFFER_PRODUCTS = {
	DEFERRED_PAYMENT: 'DEFERRED_PAYMENT',
	PAY_IN_THREE: 'PAY_IN_THREE',
	BOTH: 'BOTH',
} as const;

export type BnplLimitsOfferProducts =
	(typeof BNPL_LIMITS_OFFER_PRODUCTS)[keyof typeof BNPL_LIMITS_OFFER_PRODUCTS];

export interface BnplLimitsOfferMemory {
	lastSentAt: string | null;
}
